import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=04710475&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=04710475&prod&scoped=true&lang=css"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=04710475&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04710475",
  null
  
)

export default component.exports